// Hairline SVG motifs — used in the 8 motif circles and Motif Magic.
// Each is a compact viewBox="0 0 40 40" stroke path.

export const MOTIF_PATHS = {
  butterfly: (
    <>
      <path d="M20 12 C 12 6, 4 8, 4 16 C 4 24, 12 26, 20 22" fill="none" strokeWidth="1" />
      <path d="M20 22 C 12 26, 4 30, 6 34 C 8 38, 16 34, 20 28" fill="none" strokeWidth="1" />
      <path d="M20 12 C 28 6, 36 8, 36 16 C 36 24, 28 26, 20 22" fill="none" strokeWidth="1" />
      <path d="M20 22 C 28 26, 36 30, 34 34 C 32 38, 24 34, 20 28" fill="none" strokeWidth="1" />
      <line x1="20" y1="10" x2="20" y2="30" strokeWidth="1" />
    </>
  ),
  dragonfly: (
    <>
      <line x1="20" y1="6" x2="20" y2="34" strokeWidth="1" />
      <path d="M20 14 C 10 10, 4 12, 4 16 C 4 20, 12 20, 20 18" fill="none" strokeWidth="1" />
      <path d="M20 22 C 10 22, 4 24, 4 28 C 4 32, 12 30, 20 26" fill="none" strokeWidth="1" />
      <path d="M20 14 C 30 10, 36 12, 36 16 C 36 20, 28 20, 20 18" fill="none" strokeWidth="1" />
      <path d="M20 22 C 30 22, 36 24, 36 28 C 36 32, 28 30, 20 26" fill="none" strokeWidth="1" />
    </>
  ),
  owl: (
    <>
      <circle cx="20" cy="22" r="10" fill="none" strokeWidth="1" />
      <circle cx="16" cy="20" r="2.5" fill="none" strokeWidth="1" />
      <circle cx="24" cy="20" r="2.5" fill="none" strokeWidth="1" />
      <path d="M13 14 L 17 18 M 27 14 L 23 18" strokeWidth="1" fill="none" />
      <path d="M20 24 L 18 26 L 22 26 Z" fill="none" strokeWidth="1" />
    </>
  ),
  lotus: (
    <>
      <path d="M20 30 C 14 28, 12 22, 20 12" fill="none" strokeWidth="1" />
      <path d="M20 30 C 26 28, 28 22, 20 12" fill="none" strokeWidth="1" />
      <path d="M20 30 C 10 28, 8 20, 12 14 C 16 20, 18 26, 20 30" fill="none" strokeWidth="1" />
      <path d="M20 30 C 30 28, 32 20, 28 14 C 24 20, 22 26, 20 30" fill="none" strokeWidth="1" />
      <path d="M8 30 L 32 30" strokeWidth="1" />
    </>
  ),
  hearts: (
    <>
      <path d="M20 30 C 8 22, 8 12, 14 12 C 17 12, 20 14, 20 18 C 20 14, 23 12, 26 12 C 32 12, 32 22, 20 30 Z" fill="none" strokeWidth="1" />
    </>
  ),
  car: (
    <>
      <path d="M6 24 L 10 18 L 30 18 L 34 24 L 34 28 L 6 28 Z" fill="none" strokeWidth="1" />
      <circle cx="12" cy="28" r="2.5" fill="none" strokeWidth="1" />
      <circle cx="28" cy="28" r="2.5" fill="none" strokeWidth="1" />
      <path d="M14 18 L 15 14 L 25 14 L 26 18" fill="none" strokeWidth="1" />
    </>
  ),
  bee: (
    <>
      <ellipse cx="20" cy="24" rx="8" ry="6" fill="none" strokeWidth="1" />
      <path d="M14 24 L 26 24 M 16 20 L 24 20 M 16 28 L 24 28" strokeWidth="1" />
      <path d="M12 20 C 6 16, 6 24, 12 22 M 28 20 C 34 16, 34 24, 28 22" fill="none" strokeWidth="1" />
      <line x1="20" y1="18" x2="20" y2="15" strokeWidth="1" />
    </>
  ),
  leaf: (
    <>
      <path d="M10 30 C 10 18, 22 8, 30 10 C 32 18, 22 30, 10 30 Z" fill="none" strokeWidth="1" />
      <path d="M12 28 L 28 12" strokeWidth="1" />
    </>
  ),
  bud: (
    <>
      <path d="M20 32 L 20 18" strokeWidth="1" />
      <path d="M20 18 C 12 16, 10 8, 18 8 C 18 14, 20 18, 20 18" fill="none" strokeWidth="1" />
      <path d="M20 18 C 28 16, 30 8, 22 8 C 22 14, 20 18, 20 18" fill="none" strokeWidth="1" />
      <path d="M16 32 L 24 32" strokeWidth="1" />
    </>
  ),
};

export const Motif = ({ name, size = 40, className = "", strokeColor = "currentColor" }) => {
  const path = MOTIF_PATHS[name];
  if (!path) return null;
  return (
    <svg
      className={className}
      viewBox="0 0 40 40"
      width={size}
      height={size}
      stroke={strokeColor}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {path}
    </svg>
  );
};

export const MOTIF_LIST = [
  { key: "butterfly", label: "Butterfly" },
  { key: "dragonfly", label: "Dragonfly" },
  { key: "owl", label: "Owl" },
  { key: "lotus", label: "Lotus" },
  { key: "hearts", label: "Hearts" },
  { key: "car", label: "Car" },
  { key: "bee", label: "Bee" },
  { key: "leaf", label: "Leaf" },
];
